import { AnyAction } from 'redux';
import * as actionTypes from '../actions/point';

const initialState = {
  current: {
    loaded: false,
    error: undefined,
    data: undefined,
  },
  list: {
    loaded: false,
    error: undefined,
    data: [],
  },
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    /*  GET POINT PART  */
    case `${actionTypes.POINT_GET}:reset`: {
      return {
        ...state,
        current: {
          ...initialState.current,
        },
      };
    }
    case `${actionTypes.POINT_GET}:loading`: {
      return {
        ...state,
        current: {
          ...state.current,
          loaded: false,
          error: undefined,
        },
      };
    }
    case `${actionTypes.POINT_GET}:error`: {
      return {
        ...state,
        current: {
          ...state.current,
          loaded: true,
          error: action.payload,
        },
      };
    }
    case `${actionTypes.POINT_GET}:success`: {
      return {
        ...state,
        current: {
          ...state.current,
          data: action.payload,
          loaded: true,
          error: undefined,
        },
      };
    }
    default:
      return state;
  }
};
